// components/forms/FieldRenderer.jsx
import React from "react";
import TextFieldComponent from "./TextFieldComponent";
import DropdownFieldComponent from "./DropdownFieldComponent";
import DatePickerFieldComponent from "./DatePickerFieldComponent";
import PropTypes from "prop-types";
import CheckboxFieldComponent from "./CheckboxFieldComponent";
import FileUploadComponent from "./FileUploadFieldComponent";
import RadioFieldComponent from "./RadioFieldComponent";
import TimePickerFieldComponent from "./TimePickerFieldComponent";
import TextAreaComponent from "./TextAreaFieldComponent";
import ColorPickerFieldComponent from "./ColorPickerFieldComponent";

const FieldRenderer = ({
  field,
  errors,
  touched,
  dropdownOptions,
  handleFieldChange,
  values,
  setFieldValue,
}) => {
  const commonProps = {
    field,
    errors,
    touched,
    handleFieldChange,
    values,
  };

  // console.log("field", field);

  switch (field.type) {
    case "text":
    case "email":
      return <TextFieldComponent {...commonProps} />;

    case "dropdown":
      // return;
      return (
        <DropdownFieldComponent
          {...commonProps}
          dropdownOptions={dropdownOptions}
        />
      );

    case "file":
      return (
        <FileUploadComponent
          setFieldValue={setFieldValue}
          values={values}
          {...commonProps}
        />
      );

    case "radio":
      return <RadioFieldComponent {...commonProps} />;

    case "checkbox":
      return <CheckboxFieldComponent {...commonProps} />;

    case "date":
      return (
        <DatePickerFieldComponent
          field={field}
          errors={errors}
          touched={touched}
          values={values}
          setFieldValue={setFieldValue}
        />
      );
    case "time":
      return (
        <TimePickerFieldComponent
          field={field}
          errors={errors}
          touched={touched}
          values={values}
          setFieldValue={setFieldValue}
        />
      );

    case "textarea":
      return (
        <TextAreaComponent
          field={field}
          errors={errors}
          touched={touched}
          handleFieldChange={handleFieldChange}
        />
      );

    case "colorpicker":
      return (
        <ColorPickerFieldComponent
          field={field}
          errors={errors}
          touched={touched}
          handleFieldChange={handleFieldChange}
        />
      );

    default:
      return null;
  }
};

FieldRenderer.propTypes = {
  field: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  dropdownOptions: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
    .isRequired,
  handleFieldChange: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func,
  values: PropTypes.object,
};

export default FieldRenderer;
